module.exports = __webpack_public_path__ + "media/ppp/create_fundraising_event_button/create_fundraising_event_modal-fb4b68c8eb51c8019480866f182af37a.svg";